export default "__VITE_ASSET__CkM2iqBU__"